import Env from './env'
import { setAuth, getAuth } from './api'

function mAlert(page, message) {
  page.$toast({
    message,
    position: 'middle',
    duration: 3000,
  })
}

function dynamicHost() {
  return Env.serverIp
}

function queryValue(name) {
  const query = new URLSearchParams(location.search)
  return query.get(name) || ''
}

function setTitle() {
  document.title = 'yajatravel'
}

function polishingImg(src) {
  if (!src) {
    return '#'
  }
  if (src.indexOf('http') !== -1) {
    return src
  }
  return Env.serverIp + src
}

function removeDpnClass() {
  try {
    document.getElementsByClassName('vue-dpn')[0].classList.remove('vue-dpn')
  } catch (e) {}
}

function copy(text) {
  const el = document.createElement('textarea')
  el.setAttribute('readonly', 'readonly')
  el.value = text
  document.body.appendChild(el)
  el.select()
  const ok = document.execCommand('copy')
  document.body.removeChild(el)
  return ok
}

function isTestMode() {
  return location.hostname === '127.0.0.1' || location.hostname === 'localhost'
}

function checkToken() {}

export default {
  setAuth,
  getAuth,
  mAlert,
  dynamicHost,
  queryValue,
  setTitle,
  polishingImg,
  removeDpnClass,
  copy,
  isTestMode,
  checkToken,
}
